import { render, staticRenderFns } from "./LessonPlayer.vue?vue&type=template&id=ba5941fc&scoped=true"
import script from "./LessonPlayer.vue?vue&type=script&lang=js"
export * from "./LessonPlayer.vue?vue&type=script&lang=js"
import style0 from "./LessonPlayer.vue?vue&type=style&index=0&id=ba5941fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5941fc",
  null
  
)

export default component.exports